import { MobileDatePicker } from '@mui/x-date-pickers';
import React, { FC, useRef } from 'react';
import { monthDayYearDateFormat } from '@efacity/common';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

interface CommonDatePickerProps {
  value: Date | string | undefined;
  onChange?: any;
  id?: string;
  name?: string;
  dataTestId?: string;
  label?: string;
  error?: boolean;
  helperText?: string;
  disabled?: boolean;
}

export const CommonDatePicker: FC<CommonDatePickerProps> = ({
  value,
  onChange,
  id = '',
  name = '',
  dataTestId = '',
  label = '',
  error = false,
  helperText = '',
  disabled = false
}) => {
  const dateInputRef = useRef<HTMLInputElement>(null);

  return (
    <div style={{ display: 'flex', justifyContent: 'start' }}>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <MobileDatePicker
          data-testid={dataTestId}
          format={monthDayYearDateFormat}
          value={new Date(value)}
          onChange={onChange}
          closeOnSelect
          inputRef={dateInputRef}
          disabled={disabled}
          slotProps={{
            textField: {
              variant: 'outlined',
              fullWidth: true,
              size: 'small',
              id,
              name,
              label,
              error,
              helperText,
              'aria-label': 'select date'
            }
          }}
        />
      </LocalizationProvider>
    </div>
  );
};
